module.exports = __webpack_public_path__ + "img/logo_morena.509d4958.png";